import { render, staticRenderFns } from "./BusinessBranchOrCategorySearchResultCard.vue?vue&type=template&id=5ddbd5cb&scoped=true"
import script from "./BusinessBranchOrCategorySearchResultCard.vue?vue&type=script&lang=ts"
export * from "./BusinessBranchOrCategorySearchResultCard.vue?vue&type=script&lang=ts"
import style0 from "./BusinessBranchOrCategorySearchResultCard.vue?vue&type=style&index=0&id=5ddbd5cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddbd5cb",
  null
  
)

export default component.exports